import * as React from 'react';
import Layout from '../components/Layout';
import Person from '../components/Person';
import Container from '../components/Container';
import Text from '../components/Text';
import FloatingIntroductoryCallButton from '../components/FloatingIntroductoryCallButton';

const AboutPage = () => (
    <Layout showLogo={true}>
        <Container>
            <h1 className="center">About Jodi</h1>
            <Person
                image="https://firebasestorage.googleapis.com/v0/b/jodifranklin-415b8.appspot.com/o/people%2Fjodi.jpg?alt=media&token=7fb73936-7f89-439a-930a-3cf82917eaf4"
                title="Jodi Franklin, CHC, AFMC"
                credentials={
                    <>
                        AFMC Certified in Functional Medicine Health through{' '}
                        <a href="https://schoolafm.com/?ap_id=jf" target="_blank" rel="noreferrer">
                            School of Applied Functional Medicine
                        </a>
                        .<br />
                        <a href="https://geti.in/3y49xLZ" target="_blank" rel="noreferrer">
                            Institute of Integrative Nutrition
                        </a>
                        , CHC
                        <br />
                        <a href="http://tulane.edu/" target="_blank" rel="noreferrer">
                            Tulane University
                        </a>
                        , BS
                        <br />
                        <a href="http://www.afaa.com/about" target="_blank" rel="noreferrer">
                            AFAA
                        </a>{' '}
                        Certified Fitness Instructor
                        <br />
                        <a href="http://www.acsm.org/about-acsm" target="_blank" rel="noreferrer">
                            ACSM
                        </a>{' '}
                        Certified Personal Trainer
                    </>
                }
                AFMCId="franklin-jodi"
            >
                <Text>
                    Jodi Franklin, a seasoned AFMC certified functional medicine practitioner and certified health
                    coach, boasts an impressive 35-year career dedicated to revolutionizing the health and well-being of
                    individuals worldwide. With a passion for holistic approaches and a commitment to addressing the
                    root causes of health issues, Jodi has become a prominent figure in the field.
                </Text>
                <Text>
                    Jodi has witnessed the transformative power of treating the whole person rather than isolated
                    symptoms. In her multi-modality practice, her team helps clients with autoimmune skin disorders like
                    vitiligo, urticaria and psoriasis as well as metabolic diseases (type 2 diabetes), gastrointestinal
                    issues, chronic pain, anti-aging, Parkinson’s, Alzheimer’s and anxiety. Jodi is also the founder of
                    the professional groups{' '}
                    <a href="https://www.facebook.com/groups/2096418297341795" target="_blank" rel="noreferrer">
                        Functional Medicine for Physicians, NPs, PAs and Nurses
                    </a>{' '}
                    and{' '}
                    <a href="https://www.facebook.com/groups/895786757176944" target="_blank" rel="noreferrer">
                        Health Coach Educational Network
                    </a>{' '}
                    and her group programs{' '}
                    <a href="https://www.vanishingvitiligo.com" target="_blank" rel="noreferrer">
                        Vanishing Vitiligo
                    </a>{' '}
                    and{' '}
                    <a href="https://www.savingface.me" target="_blank" rel="noreferrer">
                        Saving Face
                    </a>
                    . She is also a teaching consultant at{' '}
                    <a
                        href="https://schoolafm.com/events-learning-opportunities/?ap_id=jf"
                        target="_blank"
                        rel="noreferrer"
                    >
                        The School of Applied Functional Medicine
                    </a>
                    , where she consults with fellow practitioners on patient/client cases.
                </Text>
                <Text>
                    Jodi Franklin's commitment extends beyond her clinical practice. She is a sought-after speaker at
                    conferences, sharing her insights on Functional Medicine and advocating for a more integrative
                    approach to healthcare. With a compassionate and empathetic approach, Jodi Franklin continues to
                    impact lives positively. Her dedication to Functional Medicine exemplifies a profound commitment to
                    empowering individuals on their journey to optimal health.
                </Text>
                <strong>Here are some of her specialties:</strong>
                <ul className="row">
                    <div className="col s12 m4">
                        <li>Autoimmune Diseases</li>
                        <li>Diabetes</li>
                        <li>Skin Issues/diseases</li>
                        <li>Gastrointestinal Issues/IBD</li>
                        <li>Heart Disease</li>
                        <li>Obesity and Weight Loss</li>
                    </div>
                    <div className="col s12 m4">
                        <li>Heavy Metal Toxicity</li>
                        <li>Fertility Issues</li>
                        <li>Thyroid Issues</li>
                        <li>Hormonal Issues</li>
                        <li>Bone Health</li>
                        <li>Gastrointestinal Issues</li>
                    </div>
                    <div className="col s12 m4">
                        <li>Depression and Anxiety</li>
                        <li>Allergies and Asthma</li>
                        <li>Cancer Support</li>
                        <li>Fibromyalgia</li>
                        <li>Chronic Pain</li>
                        <li>Headaches and Migraines</li>
                    </div>
                </ul>
            </Person>
        </Container>
        <FloatingIntroductoryCallButton />
    </Layout>
);

export default AboutPage;

export const Head = () => (
    <>
        <link rel="canonical" href="https://jodifranklin.com/about" />
        <title>Jodi Franklin - About Jodi</title>
    </>
);
